module.exports = __webpack_public_path__ + "static/meta-image-7f1d666735f1066bbf7c5dbc0ae47391.png";